import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <nb-progress-bar [value]="data.value" [displayValue]="true" [status]="data.status" [nbTooltipDisabled]="!data || !data.value"
      [nbTooltip]="data.tooltip" nbTooltipStatus="default" nbTooltipPlacement="bottom">
    </nb-progress-bar>
  `,
  styleUrls: ['./progress-bar-cell.component.scss'],
})
export class ProgressBarCellComponent {
  @Input()
  data: any;

  constructor() { }
}
